// Ids match M5 reseed (20260729190000_firestore_migration_seeds): DELETE + re-INSERT with
// no explicit ids, continuing autoincrement past the 7 rows from seed_enumerations.
export var SalesOrderStatus;
(function (SalesOrderStatus) {
    SalesOrderStatus[SalesOrderStatus["DRAFT"] = 8] = "DRAFT";
    SalesOrderStatus[SalesOrderStatus["AWAITING_APPROVAL"] = 9] = "AWAITING_APPROVAL";
    SalesOrderStatus[SalesOrderStatus["SUBMITTED"] = 10] = "SUBMITTED";
    SalesOrderStatus[SalesOrderStatus["ACCEPTED"] = 11] = "ACCEPTED";
    SalesOrderStatus[SalesOrderStatus["DELIVERY_SCHEDULING"] = 12] = "DELIVERY_SCHEDULING";
    SalesOrderStatus[SalesOrderStatus["READY_TO_DELIVER"] = 13] = "READY_TO_DELIVER";
    SalesOrderStatus[SalesOrderStatus["SHIPPED"] = 14] = "SHIPPED";
    // Added later (20261105120000_sales_order_delivered_status), so its id sits after Rejected.
    SalesOrderStatus[SalesOrderStatus["DELIVERED"] = 18] = "DELIVERED";
    SalesOrderStatus[SalesOrderStatus["COMPLETE"] = 15] = "COMPLETE";
    SalesOrderStatus[SalesOrderStatus["CANCELLED"] = 16] = "CANCELLED";
    SalesOrderStatus[SalesOrderStatus["REJECTED"] = 17] = "REJECTED";
})(SalesOrderStatus || (SalesOrderStatus = {}));
//# sourceMappingURL=sales-order-status.js.map